import React from "react";
import { connect } from "react-redux";
import { closeModal } from "../actions";
import mainHelper, {apiCall} from "../helpers/MainHelper";
import ReactLoading from "react-loading";

class EventDetailModel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      title: '',
      start: '',
      end: '',
      description: '',
      status:'',
      loading: false
    };
  }

  componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
    if (prevProps.event !== this.props.event && this.props.event) {
      const {id, title, start, end, description,status } = this.props.event;
      this.setState({id, title, start, end, description,status });
    }
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleUpdateEvent = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    const {id, title, start, end, description } = this.state;
    try {
      const response = await apiCall('business/events/update/'+id, 'post', {
        title: title,
        start: start,
        end: end,
        description: description,

      });
      mainHelper.toastMessage('success', response.message);
      this.setState({ loading: false });
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  render() {
    const { isOpen } = this.props;
    const {title, start, end, description, loading } = this.state;

    const formatDateToLocalInput = date => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    };
    return (
        <div className={isOpen ? "modal fade show" : "modal fade"} role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="title" id="defaultModalLabel">Etkinlik Detayları</h4>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <div className="form-line">
                    <input
                        name="title"
                        id="title"
                        type="text"
                        className="form-control"
                        placeholder="Etkinlik başlığı"
                        value={title || ''}
                        onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-line">
                    <input
                        name="start"
                        id="start"
                        type="datetime-local"
                        className="form-control"
                        placeholder="Başlangıç tarihi"
                        value={formatDateToLocalInput(start) || ''}
                        onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-line">
                    <input
                        name="end"
                        id="end"
                        type="datetime-local"
                        className="form-control"
                        placeholder="Bitiş tarihi"
                        value={formatDateToLocalInput(end) || ''}
                        onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-line">
                  <textarea
                      name="description"
                      id="description"
                      className="form-control"
                      placeholder="Etkinlik detayı"
                      value={description || ''}
                      onChange={this.handleInputChange}
                  ></textarea>
                  </div>
                </div>
                {/*
                <div className="form-group">
                  <div className="form-line">
                    <select name="status" id='status' className="form-control"
                            value={status || ''}
                            onChange={this.handleInputChange}>
                      <option value="Devam ediyor">Devam ediyor</option>
                      <option value="Tamamlandı">Tamamlandı</option>
                    </select>
                  </div>
                </div>
                */}

              </div>
              <div className="modal-footer">
                {loading ? (
                    <button
                        className="btn btn-outline-primary btn-lg"
                        disabled={true}
                        style={{textAlign: "-webkit-center"}}
                    >
                      Lütfen Bekleyin...
                      <ReactLoading type="spin" width={'24px'} height={'24px'} color="#268bd2"/>
                    </button>
                ) : (
                    <button type="button" className="btn btn-outline-primary" onClick={this.handleUpdateEvent}>
                      Güncelle
                    </button>
                )}
                <button
                    type="button"
                    onClick={this.props.closeModal}
                    className="btn btn-simple"
                    data-dismiss="modal"
                >
                  Kapat
                </button>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({
  isOpen: mailInboxReducer.isModalOpen,
  event: mailInboxReducer.selectedEvent
});

export default connect(mapStateToProps, { closeModal })(EventDetailModel);
